import { useQuery } from '@tanstack/react-query';
import { PerformanceAnalyzeService } from '@/services/performance-analyze-service';

export const usePerformanceChart = (
  groupIds: string[],
  windowSize: number,
  startDate?: string,
  endDate?: string
) => {
  return useQuery({
    queryKey: ['performance-chart', groupIds, windowSize, startDate, endDate],
    queryFn: async () => {
      const response = await PerformanceAnalyzeService.getPerformanceData(
        groupIds,
        windowSize,
        startDate,
        endDate
      );
      
      // Transform data for Recharts
      // Merge all group data points by date
      const dateMap = new Map<string, any>();
      
      response.groups.forEach(group => {
        group.data_points.forEach(point => {
          if (!dateMap.has(point.date)) {
            dateMap.set(point.date, { date: point.date });
          }
          
          const dateData = dateMap.get(point.date);
          dateData[`winrate_${group.group_id}`] = point.winrate;
          dateData[`total_${group.group_id}`] = point.total_signals;
          dateData[`winning_${group.group_id}`] = point.winning_signals;
        });
      });

      return {
        chartData: Array.from(dateMap.values()).sort((a, b) => a.date.localeCompare(b.date)),
        groups: response.groups,
        symbols: response.symbols,
        window_size: response.window_size,
        date_range: response.date_range
      };
    },
    enabled: groupIds.length > 0,
    staleTime: 60000 // 1 minute cache
  });
};
